import React from 'react';
import styled from 'styled-components';

const SearchContainer = styled.div`
  margin: 12px 0 20px;
  position: relative;
`;

const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border-radius: 1rem;
  padding: 12px 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  border: 1px solid #f3f4f6;
  transition: all 0.2s;

  &:focus-within {
    border-color: var(--primary);
    box-shadow: 0 4px 6px -1px rgba(245, 130, 32, 0.1);
  }
`;

const Icon = styled.i`
  color: #9ca3af;
  margin-right: 12px;
  font-size: 14px;
`;

const Input = styled.input`
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  font-size: 14px;
  color: #1f2937;
  font-family: 'Inter', sans-serif;

  &::placeholder {
    color: #9ca3af;
  }
`;

const ClearButton = styled.button`
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #6b7280;
  }
`;

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ value, onChange }) => {
  return (
    <SearchContainer>
      <SearchInputWrapper>
        <Icon className="fas fa-search" />
        <Input 
          type="text" 
          placeholder="O que você está procurando hoje?" 
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {value && (
          <ClearButton onClick={() => onChange('')}>
            <Icon className="fas fa-times" style={{ margin: 0 }} />
          </ClearButton>
        )}
      </SearchInputWrapper>
    </SearchContainer>
  );
};
